/**
 * UTC date renderer
 */
import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CompanyUtilService } from '@shared/services';
import { Subscription } from 'rxjs';
import { toMoment } from '@shared/utils';
import { TIME_FORMATS } from '@config/global-constants';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xvi-utc-date-renderer',
  templateUrl: 'utc-date-renderer.component.html',
  styleUrls: ['utc-date-renderer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class XVIUtcDateRendererComponent
  implements AgRendererComponent, OnDestroy
{
  public formattedDate: string = '';
  protected subscription: Subscription = null;

  public constructor(private companyUtilService: CompanyUtilService) {}

  public agInit(params: ICellRendererParams): void {
    this.subscription = this.companyUtilService
      .getCurrentCompanyTimeZoneObs()
      .subscribe((timeZone: string) => {
        const momentTime = toMoment(params.value);
        this.formattedDate = momentTime.tz(timeZone).format(TIME_FORMATS.L);
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public refresh(params: any): boolean {
    return false;
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscription = null;
  }
}
